import definitions from "../../definitions";
import {locale, resizeLabelToFitText} from "../../utils";
import TextFormat from "../TextFormat";
import QuestTrackerPopup from "./QuestTrackerPopup";

export default class QuestTrackerDefaultPopup extends QuestTrackerPopup {
    /**
     * @param {string} type
     * @param {Quest} quest
     * @param {string} [message=""]
     * @param {PIXI.Texture} [icon=PIXI.Texture.EMPTY]
     */
    constructor(type, quest, message = "", icon = PIXI.Texture.EMPTY, iconScale = 1) {
        super(type, quest);

        this._message = message.trim();
        this._iconTexture = icon;

        this._nameLabel = null;
        this._descriptionLabel = null;
        this._icon = null;
        this._iconScale = iconScale;
    }

    init() {
        super.init();

        let name = locale(this._quest.name);
        if (this._message.length > 0) {
            name += " - " + this._message;
        }
        this._nameLabel = new PIXI.BitmapText(name.toUpperCase(), {
            fontName: "Alghera Pro",
            fontSize: 26,
            align: "left",
            tint: 0x000000
        });
        this._nameLabel.position.set(86, 44);
        this._nameLabel.anchor.set(0, 1);
        this.addChild(this._nameLabel);
        resizeLabelToFitText(this._nameLabel, 220); 

        const text = TextFormat.formatTextVar(locale(this._quest.description), definitions.TEXT_FORMAT_VAR.TARGET, this._quest.target);
        this._descriptionLabel = new PIXI.BitmapText(text, {
            fontName: "Alghera Pro",
            fontSize: 20,
            align: "left",
            tint: 0x702311
        });
        this._descriptionLabel.position.set(86, 50);
        this._descriptionLabel.anchor.set(0, 0);
        this.addChild(this._descriptionLabel);
        resizeLabelToFitText(this._descriptionLabel, 220);

        this._icon = new PIXI.Sprite(this._iconTexture);
        this._icon.position.set(330, 42);
        this._icon.anchor.set(0.5);
        this._icon.scale.set(this._iconScale);
        this.addChild(this._icon);
    }

    /**
     * @return {string}
     */
    get message() {
        return this._message;
    }
}